// Lets an event/campaign hand out a URL (e.g. via a QR code) instead of a
// spelled-out Stripe coupon code — people mistype coupon codes constantly,
// but a scanned link never does. Capture happens once wherever the QR lands
// (landing page, /register, anywhere), and localStorage carries it across
// the registration → plan-selection flow, which involves real page loads
// in between (email verification, MeLi OAuth, etc.) that a query param or
// React state alone wouldn't survive.
const STORAGE_KEY = 'selltrix_referral_coupon';

export function captureCouponFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const coupon = params.get('coupon');
  if (!coupon) return;

  // Stripe coupon ids are case-sensitive (e.g. "Evento2025" and "EVENTO2025"
  // can be two different coupons) — preserve exactly what's in the URL.
  localStorage.setItem(STORAGE_KEY, coupon.trim());

  // Drop it from the address bar so it doesn't linger in a bookmarked or
  // re-shared URL.
  params.delete('coupon');
  const query = params.toString();
  const cleanUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
  window.history.replaceState({}, '', cleanUrl);
}

export function getStoredCoupon() {
  return localStorage.getItem(STORAGE_KEY) || '';
}

// Consultant affiliate links (?ref=CODE, see backend services/affiliates.py)
// travel the same way: captured on any landing route, sent with registration
// and again at checkout (for signups that didn't go through /register).
const REFERRAL_STORAGE_KEY = 'selltrix_affiliate_ref';

export function captureReferralFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (!ref) return;

  localStorage.setItem(REFERRAL_STORAGE_KEY, ref.trim().toUpperCase());

  params.delete('ref');
  const query = params.toString();
  const cleanUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
  window.history.replaceState({}, '', cleanUrl);
}

export function getStoredReferral() {
  return localStorage.getItem(REFERRAL_STORAGE_KEY) || '';
}

export function clearStoredReferral() {
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
}
